module.exports = __webpack_public_path__ + "static/022_001-9be275c874f0a8b3a8cf5f6b61598672.jpg";